import { Container, Ransom } from '@/components';

export const ErrorPage = () => {
  return (
    <div
      className="ww-grain flex min-h-screen items-center"
      style={{ background: 'var(--paper-100)' }}>
      <Container max={760}>
        <div className="flex flex-col items-center text-center">
          <div className="ww-eyebrow" style={{ color: 'var(--ww-orange)' }}>
            Fehler
          </div>
          <div
            className="mt-3 font-disp uppercase leading-none text-ww-charcoal"
            style={{ fontSize: 'clamp(64px, 14vw, 130px)' }}>
            Ups.
          </div>
          <div className="mt-3">
            <Ransom text="DA IST WAS SCHIEFGELAUFEN" size={30} seed={7} />
          </div>
          <p className="mt-6 max-w-[440px] font-sans text-lg leading-relaxed text-ink-soft">
            Etwas ist schiefgelaufen. Versuch es später noch einmal oder geh zurück zum Start.
          </p>
          <a href="/" className="ww-btn ww-btn--primary ww-btn--lg mt-8">
            Zurück zum Start →
          </a>
        </div>
      </Container>
    </div>
  );
};
